import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useParams } from 'react-router-dom';
import Topbar from '../../components/Bar/Topbar';
import Header from '../../components/Bar/Header';
import Footer from '../../components/Footer/Footer';
import MainContainer3 from '../../components/Carousel/MainContainer3';
import ServicePage from '../../components/Servicepages/ServicePage';
import BannerLifeStyle from '../../components/Servicepages/BannerLifeStyle';

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.8, ease: 'easeOut' } },
};

const LifeStyleEvation = () => {
  const { titre } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <style>{`
        .lifestyle-page {
          background: #FFFFFF;
          min-height: 100vh;
          position: relative;
          overflow: hidden;
        }

        /* Halos dorés subtils */
        .lifestyle-page::before,
        .lifestyle-page::after {
          content: '';
          position: fixed;
          border-radius: 50%;
          filter: blur(120px);
          opacity: 0.12;
          z-index: 0;
          pointer-events: none;
        }

        .lifestyle-page::before {
          width: 50vw;
          height: 50vw;
          background: #F5E1C8;
          top: -10%;
          left: -5%;
          animation: floatOrb 18s ease-in-out infinite;
        }

        .lifestyle-page::after {
          width: 40vw;
          height: 40vw;
          background: #EAD5C0;
          bottom: -8%;
          right: -4%;
          animation: floatOrb 15s ease-in-out infinite alternate-reverse;
        }

        @keyframes floatOrb {
          0% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(5%, 10%) scale(1.15); }
          100% { transform: translate(-5%, 5%) scale(0.9); }
        }

        .content-wrapper {
          position: relative;
          z-index: 1;
        }

        .page-title {
          font-size: clamp(2rem, 5vw, 2.5rem);
          font-weight: 700;
          color: #3B2F2A;
          text-align: center;
          margin: 0 0 0.5rem;
          letter-spacing: -0.5px;
          padding-top: 20px;
        }

        .title-underline {
          width: 80px;
          height: 3px;
          background: linear-gradient(90deg, #C69C6D, #B88A56);
          margin: 0 auto 30px;
          border-radius: 2px;
        }
      `}</style>


      <Header />

      <motion.div
        className="lifestyle-page"
        variants={pageVariants}
        initial="initial"
        animate="animate"
      >
        <div className="content-wrapper">
          {/* Titre dynamique optionnel – peut être géré par BannerLifeStyle */}
          <BannerLifeStyle titre={titre} />
          <ServicePage titre={titre} />
        
        </div>
      </motion.div>

      <Footer />
    </>
  );
};

export default LifeStyleEvation;